import { render, staticRenderFns } from "./BuyBoxCountrySwitcher.vue?vue&type=template&id=38273ef1&scoped=true"
import script from "./BuyBoxCountrySwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxCountrySwitcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxCountrySwitcher.vue?vue&type=style&index=0&id=38273ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38273ef1",
  null
  
)

export default component.exports